import React from "react";

import { useAppSelector } from "web/hooks";
import { getObservations } from "web/app_slice";
import BirdTable from "web/ui/pages/bird_table";

import classes from './birds_page.module.css';

const BirdsPage = () => {
  const allObservations = useAppSelector(getObservations);

  return <div className={ classes.root }>
    <BirdTable allObservations={ allObservations } />
  </div>
}

export default BirdsPage;
